import Vue from "vue";

const state = {
  /**
   * Dialog na výběr firmy.
   * Parmetry žádné, pouze nenulová položka
   */
  companySelection: null,

  /**
   * Dialog na výběr skupiny.
   * Parmetry žádné, pouze nenulová položka
   */
  groupsetSelection: null,

  /**
   * Dialog na výběr vozidla.
   * Parmetry žádné, pouze nenulová položka
   */
  vehicleSelection: null,

  /**
   * Dialog na hledání vozidla.
   * Parmetry žádné, pouze nenulová položka
   */
  findVehicle: null,

  /**
   * Dialog na vložení tankování.
   * Parmetry žádné, pouze nenulová položka
   */
  refueling: null,

  /**
   * Dialog na zobrazeni logu vozidla.
   * Parmetr je vozidlo
   */
  vehicleLog: null,

  /**
   * Dialog na upravu parametrů jízdy.
   * Parmetr je jizda (ride)
   */
  rideUpdate: null,

  /**
   * Dialog na upravu provozních parametrů vozidla.
   * Parmetr je vozidlo (vehicle)
   */
  vehicleUpdate: null
};

const actions = {
  showDialog({ commit }, params) {
    commit("showDialog", { dialog: params.dialog, options: params.options });
  },

  hideDialog({ commit }, dialog) {
    commit("hideDialog", { dialog: dialog });
  }
};

const mutations = {
  showDialog(state, params) {
    Vue.set(state, params.dialog, params.options);
  },

  hideDialog(state, params) {
    Vue.set(state, params.dialog, null);
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations
};